<template>
  <div class="footer-box">
    <div class="footer-box-content">
      <div class="top-box">
        <img
          src="../../assets/displayPage/footer-logo.png"
          alt=""
          class="logo"
        />

        <div class="top-box-item">
          <div class="flex-align-center">
            <img src="../../assets/displayPage/email.png" alt="" srcset="" />
            E-MAIL
          </div>
          <div>电子邮箱 info@louyy.com</div>
        </div>
        <div class="top-box-item">
          <div class="flex-align-center">
            <img
              src="../../assets/displayPage/iphone.png"
              alt=""
              srcset=""
              style="width: 20px"
            />
            TEL
          </div>
          <div>联系电话 010-62970616</div>
        </div>
        <div class="top-box-item">
          <div class="flex-align-center">
            <img
              src="../../assets/displayPage/address.png"
              alt=""
              srcset=""
              style="width: 18px"
            />
            ADDRESS
          </div>
          <div>通讯地址 北京市海淀区中关村软件园一期2A号楼</div>
        </div>
      </div>
      <div class="bottom-box">
        @ 2021 楼宇|京ICP备20032023号|版权所有 北京优动空间科技有限公司|LOUYY.CO
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer-box {
  width: 100%;
  height: 220px;
  background: #2f3034;
  border-radius: 0px 0px 0px 0px;
  .footer-box-content {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    .top-box {
      height: 141px;
      width: 100%;
      display: flex;
      box-sizing: border-box;
      padding-top: 40px;
      justify-content: space-between;
      border-bottom: 1px solid #ffffff;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 23px;
      .logo {
        width: 103px;
        height: 39px;
      }
    }
    .bottom-box {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      margin-top: 28px;
      line-height: 23px;
      text-align: center;
    }
  }
}

.flex-align-center {
  display: flex;
  align-items: center;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 23px;
  margin-bottom: 15px;
  img {
    width: 24px;
    height: 20px;
    margin-right: 10px;
  }
}
</style>
